import { executeRequest, JFSRequest } from '@jfs/network'
import { clean } from '../utils'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const getRequest = (data: any) => {
  const cleanedOject = clean(data)

  return {
    ...cleanedOject,
    id: parseInt(data?.id),
  }
}

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const updateEntityMaster = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.entityMasterUpdate),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequest(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { updateEntityMaster }
